export default {"src":"/_next/static/media/UPenn.53657252.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};